import React from 'react';

export default function GiBillStudentsModalContent() {
  return (
    <p>
      The number of Veterans, service members and family members using their GI
      Bill benefits attending this school in the last calendar year. This
      includes all chapters of the GI Bill program (e.g., Post-9/11, Montgomery
      GI Bill, Reserve Education Assistance Program, and Veteran Readiness and
      Employment). Keep in mind that differences in attendee numbers don’t
      necessarily mean one school is more military friendly than another. This
      information will be updated annually.
    </p>
  );
}
